import { Typography } from '@mui/material';

import { ActiveGreen } from '../../assets/svg/ActiveGreen';
import { ActiveRed } from '../../assets/svg/ActiveRed';
import { ActiveYellow } from '../../assets/svg/ActiveYellow';
import { InactiveGreen } from '../../assets/svg/InactiveGreen';
import { InactiveRed } from '../../assets/svg/InactiveRed';
import { InactiveYellow } from '../../assets/svg/InactiveYellow';
import useTranslation from '../../hooks/useTranslation';
import DocumentLink from '../DocumentLink/DocumentLink';
import { DescStyles, RiskStyles } from './RiskColor.styles';

type Props = {
    riskColor: string | undefined;
};

const RiskColor = ({ riskColor }: Props) => {
    const translate = useTranslation();
    return (
        <>
            <RiskStyles>
                {riskColor === 'GREEN' ? <ActiveGreen /> : <InactiveGreen />}
                {riskColor === 'YELLOW' ? <ActiveYellow /> : <InactiveYellow />}
                {riskColor === 'RED' ? <ActiveRed /> : <InactiveRed />}
            </RiskStyles>
            <DescStyles>
                <Typography variant="body2">
                    {riskColor === 'GREEN'
                        ? translate('field.risk-color.text.green')
                        : riskColor === 'YELLOW'
                          ? translate('field.risk-color.text.yellow')
                          : translate('field.risk-color.text.red')}
                </Typography>
                <Typography variant="body2">
                    <DocumentLink
                        href={translate('field.risk-color.link.url')}
                        text={translate('field.risk-color.link.label')}
                    />
                </Typography>
            </DescStyles>
        </>
    );
};

export default RiskColor;
